import { createConfigurable } from '@peloton/config-singleton/createConfigurable';

export const { config, updateConfig } = createConfigurable<{
  streamSource: 'primary' | 'multichannel';
}>({
  streamSource: 'multichannel',
});
